import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import du Service Worker (on importe tout l'objet pour la robustesse)
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// CORRECTION DÉFINITIVE : 
// On appelle register() uniquement en mode production.
// On ne tente plus d'appeler unregister() en développement car il n'est pas exporté,
// ce qui corrige l'erreur de compilation. L'erreur Service Worker en console sera ignorée
// en développement car le bundler sait qu'il n'est pas en production.
if (process.env.NODE_ENV === 'production') {
    //serviceWorkerRegistration.register();
} else {
    // Si nous sommes en mode développement et que unregister n'est pas exporté, 
    // l'erreur Service Worker de MIME type peut persister, mais l'application compile.
    console.warn("Service Worker non enregistré en DEV. Veuillez ignorer l'erreur de MIME type Service Worker.");
}

// Optionnel : mesure des performances
reportWebVitals();
